import React from "react";
import {Route, useRouteMatch} from "react-router-dom";
import DashboardManager from "../views/manager/DashboardManager";
import {compose} from "recompose";
import NewAffinity from "../views/manager/NewAffinity";
import ManageAffinities from "../views/manager/ManageAffinities";
import Configuration from "../views/manager/Configuration";
import {withMasterContextProvider, withMasterContextReady} from "../context/MasterContext";
import {withIndicatorsContextProvider, withIndicatorsContextReady} from "../context/MasterContext/IndicatorsContext";

const MasterRoutes = () => {
    const {path} = useRouteMatch();

    return (
        <>
            <Route path={`${path}/dashboard`} component={DashboardManager}/>
            <Route path={`${path}/new-affinity`} component={NewAffinity}/>
            <Route path={`${path}/afinidades`} component={ManageAffinities}/>
            <Route path={`${path}/configuration`} component={Configuration}/>
        </>
    )


}

export default compose(
    withMasterContextProvider,
    withMasterContextReady,
    withIndicatorsContextProvider,
    withIndicatorsContextReady
)(MasterRoutes);